// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb15[data-v-7e9bb440] {\n  margin-bottom: 15px;\n}\n.form-unit[data-v-7e9bb440] {\n  margin-left: 8px;\n  color: #606266;\n  font-size: 13px;\n}\n.danger-text[data-v-7e9bb440] {\n  color: #f56c6c;\n}", ""]);
// Exports
module.exports = exports;
